// extracted by mini-css-extract-plugin
export default {"resetButton":"xp2r9xv","link":"kxzqQ_x"};